import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { QuestionAnswerOutlined } from '@mui/icons-material';
import { useTranslation } from '../../hooks/useTranslation';
import BaseSidebar, { CustomSubMenu, Item } from './BaseSidebar';
import PercentOutlinedIcon from '@mui/icons-material/PercentOutlined';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';

const SidebarRepresentative = () => {
  const { t } = useTranslation();

  return (
    <BaseSidebar includeHeight={true}>
      {({ selectedSubmenu, setSelectedSubmenu }) => (
        <>
          <Item
            title={t('sidebar.dashboard')}
            to="/app/dashboard"
            icon={<HomeOutlinedIcon />}
            setSelectedSubmenu={setSelectedSubmenu}
          />

          {/* Submenu Simulations */}
          <CustomSubMenu
            title={t('sidebar.simulations')}
            icon={<PercentOutlinedIcon />}
            selectedSubmenu={selectedSubmenu}
            setSelectedSubmenu={setSelectedSubmenu}
            submenuKey="simulations"
          >
            {/* TODO
            <Item
              title="Red 25 - Mensal"
              to="red25"
              submenuKey="simulations"
              setSelectedSubmenu={setSelectedSubmenu}
            />

            <Item
              title="Red 25 - Trimestral"
              to="red25tri"
              submenuKey="simulations"
              setSelectedSubmenu={setSelectedSubmenu}
            />

            <Item
              title="Red 25 - Semestral"
              to="red25sem"
              submenuKey="simulations"
              setSelectedSubmenu={setSelectedSubmenu}
            /> */}

            <Item
              title={t('sidebar.redRural')}
              to="/app/redrural"
              submenuKey="simulations"
              setSelectedSubmenu={setSelectedSubmenu}
            />
          </CustomSubMenu>

          {/* <CustomSubMenu 
            title={t('sidebar.registrations')} 
            icon={<PersonAddAltOutlinedIcon />}
            selectedSubmenu={selectedSubmenu}
            setSelectedSubmenu={setSelectedSubmenu}
            submenuKey="registrations"
          >

            <Item
              title="Cadastro Empresa"
              to="form"
              submenuKey="registrations"
              setSelectedSubmenu={setSelectedSubmenu}
            />

            <Item
              title={t('sidebar.companies')} 
              to="business"
              submenuKey="registrations"
              setSelectedSubmenu={setSelectedSubmenu}
            />

            <Item
              title={t('sidebar.clientRegistrations')} 
              to="createUser"
              submenuKey="registrations"
              setSelectedSubmenu={setSelectedSubmenu}
            />

            <Item
              title={t('sidebar.resaleRegistrations')} 
              to="resale"
              submenuKey="registrations"
              setSelectedSubmenu={setSelectedSubmenu}
            />
          </CustomSubMenu> */}

          <Item
            title={t('sidebar.faq')}
            to="/app/help"
            icon={<QuestionAnswerOutlined />}
            setSelectedSubmenu={setSelectedSubmenu}
          />
        </>
      )}
    </BaseSidebar>
  );
};

export default SidebarRepresentative;
